import React from 'react'

const types = ['primary','secondary','success','danger','warning','info','light','dark']

export default class Alert extends React.Component {
  render() {
    const index = typeof(this.props.type)==='string'&&types.indexOf(this.props.type)>=0?this.props.type:0
    const className = `alert alert-${types[index]} ${this.props.className}`
    return (
      <div className={className} role="alert">
        {this.props.value}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert.js